import { useState } from "react";

import { Intro, Main } from "../components/";
import { useTransition, animated } from "@react-spring/web";

export default function Home() {
  const [start, setStart] = useState(false);
  const transitions = useTransition(start, {
    from: { opacity: 0, transform: "translate3d(0,50px,0)", display: "none" },
    enter: {
      opacity: 1,
      transform: "translate3d(0%,0,0)",
      display: "block",
      delay: 300,
    },
    leave: { opacity: 0, transform: "translate3d(0%,-50px,0)" },
    config: { duration: 300 },
  });

  const startHandler = () => {
    setStart(true);
  };

  return transitions((styles, item) =>
    item ? (
      <animated.div style={{ ...styles }}>
        <div className="container" style={{ display: "flex" }}>
          <Main />
        </div>
      </animated.div>
    ) : (
      <animated.div
        style={{
          ...styles,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      >
        <Intro startHandler={startHandler} />
      </animated.div>
    )
  );
}
